import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import maplayout from "../../helper/MapStyle";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
 import PropTypes from "prop-types"; // Import PropTypes
import { driver } from "driver.js";
 import { MAPKEY } from "../../axiosInstance";
import { useBlogContext } from "../../fetchdata/BlogContext";
const currentIcon = {
  url: "/assets/img/dot.svg",
  scaledSize: { width: 40, height: 40 },
};

const Home = () => {

const navigate = useNavigate();

 const { LoadingCategoryProduct,CategoryProduct}  = useBlogContext();

  const [selectedLocation, setSelectedLocation] = useState("");
 
  const [showSheet, setShowSheet] = useState(false);
const [selectedCategory, setSelectedCategory] = useState(null);
 
  // Function to handle geolocation request
  const fetchGeolocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${MAPKEY}`
          )
            .then((response) => response.json())
            .then((data) => {
              const address = data.results[0].formatted_address;
              setSelectedLocation(address);
              localStorage.setItem("selectedLocation", address);
              localStorage.setItem("latitude", latitude);
              localStorage.setItem("longitude", longitude);
            })
            .catch((error) => {
              console.error("Error fetching current location:", error);
              toast.error("Error fetching current location");
            });
        },
        (error) => {
          console.error("Error getting user location:", error);
          toast.error("Error getting user location");
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      toast.error("Geolocation is not supported by this browser.");
    }
  };

  // Function to initialize the map
  const initMap = () => {
    const map = new window.google.maps.Map(document.getElementById("map"), {
      center: { lat: 0, lng: 0 },
      zoom: 15,
      disableDefaultUI: true,
      styles: maplayout,
    });

    if (selectedLocation !== "") {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: selectedLocation }, (results, status) => {
        if (status === "OK") {
          map.setCenter(results[0].geometry.location);
          new window.google.maps.Marker({
            map,
            position: results[0].geometry.location,
            icon: currentIcon,
            scaledSize: new window.google.maps.Size(40, 40),
          });
        } else {
          console.error("Geocode was not successful for the following reason:", status);
        }
      });
    }
  };

  useEffect(() => {

    const location = localStorage.getItem("selectedLocation");
    if (location) {
      setSelectedLocation(location);
    } else {

      const driverObj = driver({
        showProgress: true,
        steps: [
          { element: '#select-location', popover: { title: 'Select Location First', description: 'Please choose your location to proceed.', side: "left", align: 'start' } },
        //   { element: '#valetbox', popover: { title: 'Choose Valet', description: 'Select this for valet service to handle parking. Our staff will ensure your vehicle is parked and returned promptly.', side: "left", align: 'end' } },
        //    { popover: { title: "You're All Set!", description: "Congratulations! You can now access all our services, including local, outstation, and valet options." } }
        // 
        ]
      });

      // // Add an event listener to stop the tour on click
      // document.addEventListener('click', function () {
      //   driverObj.stop();
      // });
      // // Add an event listener to stop the tour on page unload
      // window.addEventListener('beforeunload', function () {
      //   driverObj.stop();
      // });

      const timer = setTimeout(() => {

        driverObj.drive();

      }, 1000); // 2 seconds

      // Cleanup function to clear the timeout if the component unmounts
      return () => clearTimeout(timer);

    }
  }, []);

  useEffect(() => {
    const loadMapScript = () => {
      if (selectedLocation !== "") {
        if (!document.querySelector(`script[src*="https://maps.googleapis.com/maps/api/js"]`)) {
          const script = document.createElement("script");
          script.src = `https://maps.googleapis.com/maps/api/js?key=${MAPKEY}&libraries=places&callback=initMap`;
          script.async = true;
          script.defer = true;
          window.initMap = initMap;
          document.body.appendChild(script);
        } else {
            if (window.google && window.google.maps) { 
          initMap();
            }
        }
      }
    };

    loadMapScript();

    return () => {
      window.initMap = null;
    };
  }, [selectedLocation]);



  return (
    <>

 
 {showSheet && (
  <>
    {/* Background Overlay */}
    <div className="custom-overlay" onClick={() => setShowSheet(false)}></div>

    {/* Bottom Sheet */}
    <div className="custom-bottom-sheet">
      
      {/* Close Button */}
      <div className="close-btn" onClick={() => setShowSheet(false)}>
        ✕
      </div>

      <h4 className="fw-bold mb-4">
        {selectedCategory?.title}
      </h4>

      <div className="row">
        {CategoryProduct?.products
          ?.filter((p) =>
            p.Category.includes(selectedCategory?._id)
          )
          .map((product) => (
            <div
              className="col-6 text-center mb-4"
              key={product._id}
              onClick={() => {
                setShowSheet(false);
                navigate(`/product/${product.slug}`);
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="product-card bg-primary-light border border-primary p-3">
                <img
                  src={product.pImage}
                  className="img-fluid mb-2"
                  style={{ height: "70px", objectFit: "contain" }}
                  alt={product.title}
                />
                <h5 className="mb-0">{product.title}</h5>
              </div>
            </div>
          ))}
      </div>
    </div>
  </>
)}

 


      <main className="page-content  mypadding">
        <Header />
        <div className="container px-0 ">
          <div
            id="map"
            style={{ height: "40vh", width: "100%" }}
            className="rounded-md homemap"
          >
            <div
              style={{ height: "50vh", width: "100%" }}
              className="d-flex justify-content-center align-items-center flex-column"
            >
              <i className="ri-error-warning-fill fs-1 text-warning"></i>
              <p className="fs-3">Select Location First</p>
            </div>
          </div>

          <div className="bg-white rounded-md  p-3 shadow-sm mt-3">
            <div className="d-flex align-items-center justify-content-between mb-2 mt-2">
              <div className="d-flex align-items-center gap-3">
                <div>
                  <p className="m-0 font-size-14 txt-grey"> Hey User</p>
                  <h2 className="fw-bolder mb-1 font-size-22">
                    {/* {" "} {JSON.stringify(import.meta.env.VITE_REACT_APP_LOGIN_KEY)} */}
                    Where are you going?

                  </h2>{" "}
                </div>
              </div>
            </div>
            <div className="row">
{
  LoadingCategoryProduct
    ? Array.from({ length: 2 }).map((_, i) => (
        <div className="col-6" key={i}>
          <div className="p-3 borderborder-2 rounded bg-primary-light border border-primary  position-relative overflow-hidden">
            <div className="skeleton skeleton-text mb-2 col-6" />
            <div className="skeleton skeleton-text small mb-2 mt-3 col-4" />
            <div className="skeleton skeleton-img position-absolute " style={{height:'70%',width:'30%',top:'10px',right:'10px'}} />
          </div>
        </div>
      ))
    : CategoryProduct?.categories?.map((category) => (
   <div
  className="col-6"
  key={category._id}
  onClick={() => {
    setSelectedCategory(category);
    setShowSheet(true);
  }}
  style={{ cursor: "pointer" }}
>
  <div className="text-dark p-3  border-2 rounded bg-primary-light border border-primary position-relative">
    <h4 className="text-dark">{category.title}</h4>
    <p>{category.slide_para}</p>
    <img
      src={category.image}
      style={{ maxWidth: "40%" }}
      className="position-absolute top-0 end-0 p-2"
      alt={category.title}
    />
  </div>
</div>

      ))
}

    
 
            </div>
          </div>
        </div>
        <br /> <br /> <br />
      </main>

      <NavBar />

      {/* <Footer /> */}
    </>
  );
};





export default Home;
